module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTabActive()),
      expression: "isTabActive()"
    }],
    staticClass: "p-tabview-panel",
    attrs: {
      "role": "tabpanel"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d271ce6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/tabpanel/TabPanel.vue
// module id = 2167
// module chunks = 0